<template>
  <BundleSummaryCard>
    <template #image>
      <ResponsiveImage
        v-if="product.profileImage"
        :image="product.profileImage"
        :alt="product.title"
        :width="96"
        class="w-24 h-24"
      />
    </template>

    {{ formatTitle(product.title) }}

    <template #actions>
      <PlusMinusInput
        v-if="editable"
        v-model="quantity"
        :min="0"
        :max="store.MAX_SIZE"
        :increase-disabled="store.quantityAtMaximum"
        class="w-full h-[42px] max-w-[126px]"
        :sku="product.sku"
        :title="product.title"
      />
      <div
        v-else
        class="flex-center bg-gray-100 font-semibold w-full h-9"
      >
        {{ quantity }}
      </div>
    </template>
  </BundleSummaryCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useBundleStore } from '@/stores'
import BundleSummaryCard from './bundle-summary-card.vue'
import ResponsiveImage from '@/components/shared/v2/responsive-image.vue'
import type { BundleProductSelection } from '@/types/bundle'
import { PlusMinusInput } from '@oatsovernight/storybook'
export interface Props {
  selection: BundleProductSelection
  editable?: boolean
}
const props = defineProps<Props>()
const store = useBundleStore()

const { product } = props.selection
const quantity = computed({
  get: () => store.selection[props.selection.key] || 0,
  set: (value: number) => store.updateQuantity(props.selection.key, value)
})

const formatTitle = (title: string) => title.replace('Instant Protein Coffee', '')
</script>
